import HeroBanner from './components/HeroBanner';
import ProductNavGrid from './components/ProductNavGrid';
import CoreAdvantages from './components/CoreAdvantages';
import ApplicationScenarios from './components/ApplicationScenarios';
import CustomerCases from './components/CustomerCases';
import NewProducts from './components/NewProducts';
import ResourceDownload from './components/ResourceDownload';
import ConsultationForm from './components/ConsultationForm';

function HomePage() {
  return (
    <>
      <HeroBanner />
      <ProductNavGrid />
      <CoreAdvantages />
      <ApplicationScenarios />
      <CustomerCases />
      <NewProducts />
      <ResourceDownload />
      <ConsultationForm />
    </>
  );
}

export default HomePage;